import React from 'react'

const helpStyle = { padding: '8px' }
export default function HelpText({ children }) {
  return <p style={helpStyle}>{children}</p>
}
